import React, { useState } from 'react'
import apiClient from '../utils/apiClient'
import { useNavigate } from 'react-router-dom'
import { setTokens, removeAllTokens } from '../utils/tokenUtils'
import { authService } from '../utils/authService'

const Login: React.FC = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const handleLogin = async () => {
    if (!email || !password) {
      return
    }

    setIsLoading(true)
    
    // 기존 토큰 제거
    removeAllTokens()

    try {
      const response = await apiClient.post('/auth/admin-login', {
        email,
        password,
      })

      console.log('로그인 응답:', response)

      // 백엔드에서 헤더로 토큰을 전송하는 경우
      const accessToken = response.headers['access-token'] || response.headers['accessToken']
      const refreshToken = response.headers['refresh-token'] || response.headers['refreshToken']
      
      // 또는 응답 body에서 토큰을 받는 경우
      const bodyAccessToken = response.data?.accessToken
      const bodyRefreshToken = response.data?.refreshToken
      
      // 최종 토큰 결정 (헤더 우선, 없으면 body에서)
      const finalAccessToken = accessToken || bodyAccessToken
      const finalRefreshToken = refreshToken || bodyRefreshToken
      
      if (finalAccessToken && finalRefreshToken) {
        // 로컬 스토리지에 토큰 저장
        setTokens(finalAccessToken, finalRefreshToken)
        
        // authService에 로그인 성공 알림
        authService.onLoginSuccess()
        
        console.log('로그인 성공!')
        
        // 로그인 성공 시 어드민 페이지로 이동
        navigate('/admin')
      } else {
        console.log('토큰을 받지 못했습니다. 잠시 후 다시 시도합니다.')
        // 토큰을 받지 못한 경우 잠시 후 다시 시도
        setTimeout(() => {
          handleLogin()
        }, 1000)
      }
    } catch (err: any) {
      console.log('로그인 시도 중...')
      
      // 에러가 발생해도 조용히 처리하고 잠시 후 다시 시도
      setTimeout(() => {
        if (email && password) {
          handleLogin()
        }
      }, 2000)
    } finally {
      setIsLoading(false)
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && !isLoading) {
      handleLogin()
    }
  }

  return (
    <div className='min-h-screen w-full bg-black flex flex-col items-center justify-center'>
      <div className='font-pretendardBlack text-mainColor text-2xl mb-[32px]'>
        DASOM
      </div>
      <div className='w-full text-[12px] flex flex-col items-center font-pretendardRegular'>
        <input
          type='text'
          value={email}
          onChange={e => setEmail(e.target.value)}
          className='bg-subGrey h-[32px] w-[80%] max-w-[300px] rounded-[6px] mb-[16px] pl-[12px] outline-mainColor focus:ring-1 ring-white'
          placeholder='Email'
          onKeyDown={handleKeyDown}
          disabled={isLoading}
        />
        <input
          type='password'
          value={password}
          onChange={e => setPassword(e.target.value)}
          className='bg-subGrey h-[32px] w-[80%] max-w-[300px] rounded-[6px] mb-[16px] pl-[12px] outline-mainColor focus:ring-1 ring-white'
          placeholder='Password'
          onKeyDown={handleKeyDown}
          disabled={isLoading}
        />
        <div
          className={`cursor-pointer h-[32px] w-[80%] max-w-[300px] rounded-[6px] font-pretendardBold tracking-[1px] text-white flex justify-center items-center transition-colors ${
            isLoading 
              ? 'bg-gray-500 cursor-not-allowed' 
              : 'bg-mainColor hover:bg-[#00A889]'
          }`}
          onClick={isLoading ? undefined : handleLogin}
        >
          {isLoading ? '접속 중...' : '로그인'}
        </div>
      </div>
    </div>
  )
}

export default Login
